import { Component, ComponentFactoryResolver, OnDestroy, OnInit } from '@angular/core';
import { BroadcastService, EditableConfigGridData, GridBaseComponent, ModalService, ModalSize, ToasterType } from '@cv-invision/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LenderService } from '../../service/lender.service';
import { SetXpanseSettings } from '../../state/actions/global-configuration.actions';
import { GlobalConfigurationState } from '../../state/global-configuration.state';
import { CallCenterClientComponent } from './call-center-clients-form/call-center-client-form';
import { CustomActionCallCenterXpanseCellComponent } from './custom-grid-cell/custom-action-callcenter-xpanse.components';
import { XpanseCallCenterClientGridColumnsModel } from './model/expanse-client-condifg-columm.model';
import { BranchModel, DefaultSettingsModel } from './model/xpanse-default-setting.model';
import { XpanseDefaultSettingService } from './service/xpanse-default-setting.service';

@Component({
	selector: 'cv-invision-xpanse-default-setting',
	templateUrl: './xpanse-default-setting.component.html',
	styleUrls: ['./xpanse-default-setting.component.scss']
})
export class XpanseDefaultSettingComponent extends GridBaseComponent implements OnInit, OnDestroy {
	public acuityBranchSelected: Array<BranchModel>;
	public acuityLenderBranchesList: Array<BranchModel>;
	public cmpAcuityBranchSelected: Array<BranchModel>;
	public cmpAcuityLenderBranchesList: Array<BranchModel>;
	public appScopeLendersList: Array<BranchModel>;
	public clientBranchSelected: Array<BranchModel>;
	public defaultConfigModel: DefaultSettingsModel;
	public xpanseDefaultSettings: DefaultSettingsModel;
	public optionsReady: boolean;
	private atComponentDestroy = new Subject();
	saving: boolean;
	isDirtyForm: boolean;

	constructor(
		private store: Store,
		private broadcastService: BroadcastService,
		private xpanseDefaultSettingService: XpanseDefaultSettingService,
		public lenderService: LenderService,
		private modalService: ModalService,
		private componentFactoryResolver: ComponentFactoryResolver,
	) {
		super();
		this.defaultConfigModel = new DefaultSettingsModel();
		this.xpanseDefaultSettings = new DefaultSettingsModel();
		this.acuityLenderBranchesList = this.store.selectSnapshot(GlobalConfigurationState.getAcuityLenderBranches);
		this.appScopeLendersList = this.store.selectSnapshot(GlobalConfigurationState.getAppScopeLenders);
		this.cmpAcuityLenderBranchesList = this.store.selectSnapshot(GlobalConfigurationState.getCmpAcuityLenderBranches);
		this.acuityBranchSelected = [];
		this.clientBranchSelected = [];
		this.cmpAcuityBranchSelected = [];
	}

	async ngOnInit(): Promise<void> {
		this.xpanseDefaultSettingService.setFormData({ isDirty: true });
		this.gridOptions = {
			rowHeight: 40,
			rowSelection: 'single',
			defaultColDef: {
				resizable: true
			},
			localeText: {
				noRowsToShow: 'No Clients to show',
				loadingOoo: 'Loading Clients...'
			},
			columnDefs: new XpanseCallCenterClientGridColumnsModel().getColumns(),
			frameworkComponents: {
				customActionCallCenterXpanseCellComponent: CustomActionCallCenterXpanseCellComponent
			}
		};

		await this.xpanseDefaultSettingService
				  .getXpanseDefaultSettings()
				  .toPromise()
				  .then(result => {
						this.xpanseDefaultSettings = result;
						//copy data to avoid mutate the info
						this.defaultConfigModel =JSON.parse(JSON.stringify(this.xpanseDefaultSettings));
						this.gridData = this.defaultConfigModel.clients;
						if (result.defaultBranchId) {
							this.acuityBranchSelected = this.acuityLenderBranchesList.filter(
								b => b.id === this.defaultConfigModel.defaultBranchId
							);
						}

					  if (result.defaultCMPBranchId) {
						  this.lenderService.getCmpAcuityLenderBranches(result.defaultCMPBranchName)
							  .pipe(takeUntil(this.atComponentDestroy))
							  .subscribe((response : any) => {
								  this.cmpAcuityLenderBranchesList = response;

								  this.cmpAcuityBranchSelected = this.cmpAcuityLenderBranchesList.filter(
									  b => b.id === this.defaultConfigModel.defaultCMPBranchId
								  );
							  })
					  }
						if (result.defaultClientId) {
							this.clientBranchSelected = this.appScopeLendersList.filter(
								b => b.id === this.defaultConfigModel.defaultClientId
							);
							if (!this.clientBranchSelected.length) {
								this.onSearchAppScopeLender(this.defaultConfigModel);
							}
						}
						this.optionsReady = true;
				  });

		// listen to valutrust property types config editor
		this.xpanseDefaultSettingService
			.getFormDataListener()
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe((result: EditableConfigGridData) => {
				if (result.doSave !== undefined && result.doSave) {
					this.onSave();
				}
				if (result.metadata && result.metadata.reloadList) {
					// get updated info after update, create or delete any client data
					this.xpanseDefaultSettings = this.store.selectSnapshot(GlobalConfigurationState.getXpanseSettings);
					this.defaultConfigModel = JSON.parse(JSON.stringify(this.xpanseDefaultSettings));
					this.loadGridData();
				}

				if (result.isDirty !== undefined) {
					this.isDirtyForm = result.isDirty;
				}
				if (result.saving !== undefined) {
					this.saving = result.saving;
				}
			});
		this.store.dispatch(new SetXpanseSettings(this.xpanseDefaultSettings));
		this.loadGridData();
	}

	loadGridData(): void {
		this.gridData = this.defaultConfigModel.clients;
		this.gridPagination.pagination.totalCount = this.defaultConfigModel.clients.length;
	}

	/**
	 * On save search client appscope.
	 */
	onSearchAppScopeLender(configInf: any): void {
		this.lenderService
			.getLenders(configInf.defaultClientName)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(r => {
				this.clientBranchSelected = r.filter(b => b.id === configInf.defaultClientId);
				this.optionsReady = true;
			});
	}

	/**
	 * On save grid config.
	 */
	onSave(): void {
		this.xpanseDefaultSettingService
			.saveXpanseDefaultSettings(this.defaultConfigModel)
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(
				result => {
					if (result && result.succeeded) {
						this.broadcastService.broadcast({
							name: ToasterType.SUCCESS,
							event: { message: 'Default Settings saved successfully' }
						});
					}
					this.xpanseDefaultSettings = JSON.parse(JSON.stringify(this.defaultConfigModel));
					this.store.dispatch(new SetXpanseSettings(this.xpanseDefaultSettings));
					this.xpanseDefaultSettingService.setFormData({ saving: false, doSave: false });
				},
				error => {
					console.error(error);
					this.broadcastService.broadcast({
						name: ToasterType.ERROR,
						event: { error: 'Error occurred ' + error }
					});
					this.xpanseDefaultSettingService.setFormData({ saving: false, doSave: false });
				}
			);
	}

	/**
	 *call add client modal form
	 */
	addClient(): void {
		this.modalService
			.open({
				componentFactoryResolver: this.componentFactoryResolver,
				component: CallCenterClientComponent,
				data: {defualtConfig: this.defaultConfigModel, isEditing: false},
				modalConfiguration: {
					title: `Add Xpance client configuration`,
					modalSize: ModalSize.MD
				}
			})
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(result => {
				if (result.success) {
					this.xpanseDefaultSettingService.setFormData({ metadata:{reloadList:true} });
				}
			});
	}

	/**
	 * on branch selected
	 * @param $event
	 */
	onBranchSelected($event: any, type: string): void {
		switch (type) {
			case 'acuityBranch':
				this.defaultConfigModel.defaultBranchId = $event?.id || '';
				this.defaultConfigModel.defaultBranchName = $event?.title || '';
				break;
			case 'cmpacuity':
				this.defaultConfigModel.defaultCMPBranchId = $event?.id || '';
				this.defaultConfigModel.defaultCMPBranchName = $event?.title || '';
				break;
			case 'appscopeClient':
				this.defaultConfigModel.defaultClientId = $event?.id || '';
				this.defaultConfigModel.defaultClientName = $event?.title || '';
				break;
		}
	}

	ngOnDestroy(): void {
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
